export const getExchangeName = (exchName) => {
    let exchangeName;
    switch (exchName) {
        case "NSE":
        case "nse":
        case "Nse":
        case "n":
        case "N":
            exchangeName = "NSE";
            break;
        case "BSE":
        case "bse":
        case "Bse":
        case "B":
            exchangeName = "BSE";
            break;
        case "MCX":
        case "Mcx":
        case "mcx":
        case "M":
        case "m":
            exchangeName = "MCX";
            break;
    }
    return exchangeName;
};
